<template>
    <div>
        <el-dialog :title="'号码手动充值'" :visible.sync="visible" width="30%" :before-close="handleClose"
            :close-on-click-modal="false">
            <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
                <el-form-item label="充值金额" prop="feeAmount">
                    <el-input v-model="dataForm.feeAmount" placeholder="请输入充值金额（最大值为300）" type="number"></el-input>
                </el-form-item>
                <el-form-item label="号码录入:" prop="tellist">
                    <el-input type="textarea" placeholder="请输入号码
  180***8123
  180***7234
  ..." v-model="dataForm.tellist" :autosize="{ minRows: 5 }">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" :loading="confirmLoading" @click="showConfirmation">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            confirmLoading: false,
            dataForm: {
                list: null,
                feeAmount: 0,
            },
            rules: {
                tellist: {
                    required: true,
                    message: "请录入手机号",
                    trigger: "change",
                },
                feeAmount: [
                    { required: true, message: '请输入充值金额', trigger: 'blur' },
                    // { type: 'number', message: '充值金额必须是数字值', trigger: 'blur' },
                    { min: 1, message: '充值金额必须大于0', trigger: 'blur' }
                ]
            },
        };
    },
    methods: {
        init() {
            this.visible = true;
        },
        handleClose() {
            this.$refs.dataForm.resetFields();
            this.visible = false;
            this.dataForm.id = "";
        },
        showConfirmation() {
            this.$confirm('确定要充值吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.ok();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消充值'
                });
            });
        },
        ok() {
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    this.confirmLoading = true;
                    const oldtel = JSON.parse(JSON.stringify(this.dataForm.tellist));
                    if (typeof this.dataForm.tellist === 'string') {
                        this.dataForm.tellist = this.dataForm.tellist.split("\n").filter((v) => !!v);
                    }
                    // 使用JSON格式发送数据
                    const jsonData = {
                        list: this.dataForm.tellist,
                        feeAmount: this.dataForm.feeAmount
                    };
                    this.dataForm.tellist = oldtel;
                    this.$http({
                        url: "/api/FilterCaller/Recharge",
                        method: "post",
                        data: jsonData,
                        // 明确设置请求的Content-Type为application/json
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    })
                        .then((res) => {
                            if (res.data && res.data.success) {
                                this.confirmLoading = false;
                                this.$message.success(res.data.msg);
                                this.handleClose();
                                this.$emit("ok");
                            }
                        })
                        .finally(() => (this.confirmLoading = false));
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>

<style></style>